import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Services from "./components/Services";
// import Products from "./components/Products";
import Process from "./components/Process";
import TechStack from "./components/TechStack";
import Founder from "./components/Founder";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import Pricing from "./components/Pricing";
import CTA from "./components/CTA";
import Footer from "./components/Footer";
import CustomCursor from "./components/CustomCursor";
import Admin from "./pages/Admin";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import BookCall from "./pages/BookCall";
import Refund from "./pages/Refund";
import Shipping from "./pages/Shipping";
import Sitemap from "./pages/Sitemap";
import Contact from "./pages/Contact";
import About from "./pages/About";
import { setPageSeo } from "./lib/seo";

const ADMIN_PATH = process.env.REACT_APP_ADMIN_PATH || "/control-room-7x9";

const Landing = () => {
  useEffect(() => {
    document.documentElement.classList.add("dark");
    setPageSeo({
      title: "Devzcorner — One Studio. Every Discipline.",
      description:
        "Devzcorner is an end-to-end product engineering studio building web apps, AI-native systems, SaaS platforms, embedded hardware, and 3D-printed enclosures.",
      path: "/",
    });
  }, []);

  return (
    <main
      className="relative bg-ink-0 text-white overflow-x-hidden"
      data-testid="devzcorner-landing"
    >
      <CustomCursor />
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      {/* <Products /> */}
      <Process />
      <TechStack />
      <Founder />
      <Testimonials />
      <Pricing />
      <FAQ />
      <CTA />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path={ADMIN_PATH} element={<Admin />} />
          <Route path={`${ADMIN_PATH}/leads`} element={<Admin />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/book-call" element={<BookCall />} />
          <Route path="/refund" element={<Refund />} />
          <Route path="/shipping" element={<Shipping />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
        </Routes>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0a0a0a",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "#fff",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
